import { useEffect, useState, forwardRef } from "react";
import {
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  Slide,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import QRCode from "qrcode";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const QRCodeDialog = ({ open, close, title, url }) => {
  const [qrDataUrl, setQRDataUrl] = useState("");

  useEffect(() => {
    const createQR = async () => {
      const result = await QRCode.toDataURL(url);
      setQRDataUrl(result);
    };

    if (open && url) {
      createQR();
    }
  }, [open]);
  return (
    <Dialog
      open={open}
      onClose={close}
      fullScreen
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={close}>
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          p: 2,
        }}
      >
        {qrDataUrl && (
          <img
            src={qrDataUrl}
            alt="Waiver QR Code"
            style={{ width: "80%", maxWidth: 400 }}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default QRCodeDialog;
